// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"Auth_authWrapper__2frwz","logoImg":"Auth_logoImg__1HTr5","logoTitle":"Auth_logoTitle__vKbGV"};